import { render, staticRenderFns } from "./PrivacyCollection_202608.vue?vue&type=template&id=2fa5ed27&scoped=true"
import script from "./PrivacyCollection_202608.vue?vue&type=script&lang=js"
export * from "./PrivacyCollection_202608.vue?vue&type=script&lang=js"
import style0 from "./PrivacyCollection_202608.vue?vue&type=style&index=0&id=2fa5ed27&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fa5ed27",
  null
  
)

export default component.exports